import { AttrField, HasManyByField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import RecipientContact from '@/data/models/domain/RecipientContact'
import RecipientGroup from '@/data/models/domain/RecipientGroup'
import RecipientFilteredView from '@/data/models/domain/RecipientFilteredView'
import { TmArrayStringField } from '@/data/utils/types'

@OrmModel(modelNames.SCHEDULED_MESSAGE_PARAMETERS)
export default class ScheduledMessageParameters extends BaseModel {
  @StringField()
  public id: string

  @StringField()
  public text: string

  @AttrField([])
  public numbers: string[]

  @TmArrayStringField()
  public contactIds: string[]

  @HasManyByField(RecipientContact, 'contactIds')
  public contacts: RecipientContact[]

  @TmArrayStringField()
  public listIds: string[]

  @HasManyByField(RecipientGroup, 'listIds')
  public lists: RecipientGroup[]

  @TmArrayStringField()
  public filteredViewIds: string[]

  @HasManyByField(RecipientFilteredView, 'filteredViewIds')
  public filteredViews: RecipientFilteredView[]
}
